import { createAction, props } from '@ngrx/store';
import { TournamentsResponse } from '../../models/api/responses/tournaments.response';
import { AllTournamentsType } from '../reducers/allTournaments.reducer';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';

export const FETCH_ALL_TOURNAMENTS = '[All Tournaments]: Fetch All Tournaments';
export const FETCH_ALL_TOURNAMENTS_SUCCESS =
    '[All Tournaments]: Fetch All Tournaments Success';
export const FETCH_ALL_TOURNAMENTS_FAILURE =
    '[All Tournaments]: Fetch All Tournaments Failure';

export type Filter = { [key: string]: string | string[] };

export const fetchAllTournaments = createAction(
    FETCH_ALL_TOURNAMENTS,
    props<{
        payload: {
            type: AllTournamentsType;
            patchExistingTournaments: boolean;
            page: number;
            pageSize?: number;
            filters: Filter;
        };
    }>()
);

export const fetchAllTournamentsSuccess = createAction(
    FETCH_ALL_TOURNAMENTS_SUCCESS,
    props<{
        payload: {
            type: AllTournamentsType;
            patchExistingTournaments: boolean;
            response: TournamentsResponse;
        };
    }>()
);

export const fetchAllTournamentsFailure = createAction(
    FETCH_ALL_TOURNAMENTS_FAILURE,
    props<{
        payload: BadResponseWithError;
    }>()
);
